export class ContractSettings {
  constructor(
    public contractId: number,
    public mutationUser: string,
    public linearComputationMethod: string, // ComputationMethodType,
    public linearAccuracy: number,
    public linearPeriod: number,
    public pointComputationMethod: string, // ComputationMethodType,
    public pointAccuracy: number,
    public pointPeriod: number,
    public measurementCategory: string // MeasurementCategoryType
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/contract.settings.model.ts